import { render } from "./FormPQR.vue?vue&type=template&id=5612ed4e"
import script from "./FormPQR.vue?vue&type=script&lang=js"
export * from "./FormPQR.vue?vue&type=script&lang=js"

import "./FormPQR.vue?vue&type=style&index=0&id=5612ed4e&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__